import Heading from "../../SubComponents/Heading/Heading";
import "./ContactStyle.css";
import { HiOutlineMail } from "react-icons/hi";
import { MdOutlineContentCopy } from "react-icons/md";
import Form from "../../SubComponents/Form/Form";

export default function Contact() {
  const myEmail = "kanikarajpal22@gmail.com";

  return (
    <div className="contact-div" id="contact" data-aos="fade-up">
      <Heading index={4}>Get in touch</Heading>
      <div className="contact-container">
        <div className="contact-left">
          <div className="contact-heading-two">
            <div>
              <span className="blue-text">Thank you so much </span>for taking
              out your precious time to visit my portfolio!
            </div>
            <div>
              If you have any questions or would like
              <span className="orange-text"> to connect with me</span> , please
              feel free to reach out I'll do my best to get back to you as soon
              as possible.
            </div>

            <div>
              I'm always interested in new opportunities and collaborations,
              <span className="blue-text">
                {" "}
                so don't hesitate to get in touch!
              </span>
            </div>
          </div>

          <div className="mail-container">
            <HiOutlineMail size={21} color="hsla(0, 5%, 85%, 0.971)" />{" "}
            <p>{myEmail}</p>
            <button
              onClick={() => navigator.clipboard.writeText(myEmail)}
              className="btn-copy"
            >
              <MdOutlineContentCopy
                className="copy-icon"
                size={20}
                color="hsla(0, 5%, 85%, 0.971)"
              />{" "}
            </button>
          </div>
        </div>
        <div className="contact-right">
          {<Form className="form-container" />}
        </div>
      </div>
    </div>
  );
}
